<template>
  <div id="liveabcxwordup">
    <section class="banner pt-16 pb-6 skin-purple">
      <div class="container max-w-6xl mx-auto px-4">
        <div>
          <img src="~@/assets/images/liveabcxwordup/master-img.png" class="object-contain">
        </div>
      </div>
    </section>

    <section class="feature pt-6 pb-16 skin-purple">
      <div class="container max-w-6xl mx-auto px-4">
        <h5 class="text-main text-2xl md:text-4xl text-center tracking-widest font-bold">課程學習4大特色</h5>
        <div class="flex mt-6 flex-wrap">
          <div class="w-1/2 md:flex-1 px-2 z-10"><img src="~@/assets/images/liveabcxwordup/BABO-01.png" class="object-contain z-10"></div>
          <div class="w-1/2 md:flex-1 px-2 z-10"><img src="~@/assets/images/liveabcxwordup/BABO-02.png" class="object-contain z-10"></div>
          <div class="w-1/2 md:flex-1 px-2 z-10"><img src="~@/assets/images/liveabcxwordup/BABO-03.png" class="object-contain z-10"></div>
          <div class="w-1/2 md:flex-1 px-2 z-10"><img src="~@/assets/images/liveabcxwordup/BABO-04.png" class="object-contain z-10"></div>
        </div>
      </div>
    </section>

    <section class="toeic py-20 -mt-20 bg-white">
      <div class="container max-w-6xl mx-auto px-4">
        <div>
          <img src="~@/assets/images/liveabcxwordup/TITLE-01.png" class="object-contain mx-auto">
        </div>
        <div class="flex mt-6 flex-wrap">
          <a :href="item.link" class="w-full md:w-1/2 p-4 cursor-pointer" data-aos="flip-left" v-for="(item, index) in sectionData1" :key="index" :class="item.class">
            <div><img :src="item.img_url" class="object-contain img-shadow"></div>
            <div class="text-main my-6 text-center">
              <h6 class="font-bold mb-2 text-xl">{{ item.title }}</h6>
              <p>{{ item.text }}</p>
              <a class="btn-intro inline-block mt-6">看更多課程介紹</a>
            </div>
          </a>
        </div>
      </div>
    </section>

    <section class="Exam py-8 wave-bottom">
      <div class="container mx-auto px-4">
        <div>
          <img src="~@/assets/images/liveabcxwordup/TITLE-02.png" class="object-contain mx-auto">
        </div>
        <div class="flex mt-6 flex-wrap">
          <a :href="item.link" class="w-full md:w-1/2 p-4 cursor-pointer" data-aos="flip-left" v-for="(item, index) in sectionData2" :key="index" :class="item.class">
            <div><img :src="item.img_url" class="object-contain img-shadow"></div>
            <div class="text-main my-6 text-center">
              <h6 class="font-bold mb-2 text-xl">{{ item.title }}</h6>
              <p>{{ item.text }}</p>
              <a class="btn-intro inline-block mt-6">看更多課程介紹</a>
            </div>
          </a>
        </div>
      </div>
    </section>

    <section class="workplace py-24">
      <div class="container mx-auto px-4">
        <div>
          <img src="~@/assets/images/liveabcxwordup/TITLE-03.png" class="object-contain mx-auto">
        </div>
        <div class="flex mt-6 flex-wrap">
          <a :href="item.link" class="w-full md:w-1/2 p-4 cursor-pointer" data-aos="flip-left" v-for="(item, index) in sectionData3" :key="index" :class="item.class">
            <div><img :src="item.img_url" class="object-contain img-shadow"></div>
            <div class="text-main my-6 text-center">
              <h6 class="font-bold mb-2 text-xl">{{ item.title }}</h6>
              <p>{{ item.text }}</p>
              <a class="btn-intro inline-block mt-6">看更多課程介紹</a>
            </div>
          </a>
        </div>
      </div>
    </section>

    <section class="cnn py-8" style="background: #FCE292;">
      <div class="container mx-auto px-4">
        <div>
          <img src="~@/assets/images/liveabcxwordup/TITLE-04.png" class="object-contain mx-auto">
        </div>
        <div class="flex mt-6 flex-wrap">
          <a :href="item.link" class="w-full md:w-1/2 p-4 cursor-pointer" data-aos="flip-left" v-for="(item, index) in sectionData4" :key="index" :class="item.class">
            <div><img :src="item.img_url" class="object-contain img-shadow"></div>
            <div class="text-main my-6 text-center">
              <h6 class="font-bold mb-2 text-xl">{{ item.title }}</h6>
              <p>{{ item.text }}</p>
              <a class="btn-intro inline-block mt-6">看更多課程介紹</a>
            </div>
          </a>
        </div>
      </div>
    </section>

    <section class="reading py-8">
      <div class="container mx-auto px-4">
        <div>
          <img src="~@/assets/images/liveabcxwordup/TITLE-05.png" class="object-contain mx-auto">
        </div>
        <div class="flex mt-6 flex-wrap">
          <a :href="item.link" class="w-full md:w-1/2 p-4 cursor-pointer" data-aos="flip-left" v-for="(item, index) in sectionData5" :key="index" :class="item.class">
            <div><img :src="item.img_url" class="object-contain img-shadow"></div>
            <div class="text-main my-6 text-center">
              <h6 class="font-bold mb-2 text-xl">{{ item.title }}</h6>
              <p>{{ item.text }}</p>
              <a class="btn-intro inline-block mt-6">看更多課程介紹</a>
            </div>
          </a>
        </div>
      </div>
    </section>

    <footer class="py-8">
      <p class="text-center text-lg">Copyright © 2022 Hebron Soft Limited All Rights Reserved.</p>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'liveabcxwordup',
  metaInfo () {
    return {
      title: 'LiveABC X WORDUP 線上學習課程',
      titleTemplate: null
    }
  },
  components: {
  },
  data () {
    return {
      sectionData1: [
        { title: 'New TOEIC 900分突破必考單字與片語', text: '金色證書近在咫尺，多益900分必備單字片語', img_url: require('@/assets/images/liveabcxwordup/cover/toeic1.png'), class: 'w-full', link: 'https://shop.wordup.com.tw/product/62?utm_source=publisher_liveabc' },
        { title: 'TOEIC全面備戰 7大題型應考策略 + 13大情境必備詞彙', text: '初學者必看！最簡明的多益基礎參考書！', img_url: require('@/assets/images/liveabcxwordup/cover/toeic2.png'), class: 'w-full', link: 'https://shop.wordup.com.tw/product/235?utm_source=publisher_liveabc' },
        { title: 'New TOEIC 閱讀解題拿分應考對策', text: '分數卡卡怎麼辦？多益應考訣竅一次報你知', img_url: require('@/assets/images/liveabcxwordup/cover/toeic3.png'), class: 'w-full md:w-1/3', link: 'https://shop.wordup.com.tw/product/75?utm_source=publisher_liveabc' },
        { title: 'New TOEIC 新版多益完全攻略', text: '自修多益，挑戰高分全面攻略就靠這一本！', img_url: require('@/assets/images/liveabcxwordup/cover/toeic4.png'), class: 'w-full md:w-1/3', link: 'https://shop.wordup.com.tw/product/77?utm_source=publisher_liveabc' },
        { title: '4國發音TOEIC聽力題型攻略+模擬試題', text: '不同口音就慌了嗎？四種口音一次包辦！', img_url: require('@/assets/images/liveabcxwordup/cover/toeic5.png'), class: 'w-full md:w-1/3', link: 'https://shop.wordup.com.tw/product/76?utm_source=publisher_liveabc' }
      ],
      sectionData2: [
        { title: '戰勝會考國中必備英語2000字', text: '戰勝國中會考英語閱讀，只要這一本就夠', img_url: require('@/assets/images/liveabcxwordup/cover/exam1.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/378?utm_source=publisher_liveabc' },
        { title: '全民英檢初級必考關鍵2500字', text: '掌握關鍵字彙，全民英檢才能順利拿高分', img_url: require('@/assets/images/liveabcxwordup/cover/exam2.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/459?utm_source=publisher_liveabc' },
        { title: '考前16週統測總複習完全攻略', text: '紮實模擬訓練，有效率複習統測必考重點', img_url: require('@/assets/images/liveabcxwordup/cover/exam3.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/351?utm_source=publisher_liveabc' },
        { title: '戰勝學測五大題型完全攻略試題+解析', text: '循序扎根，鍛煉思維，掌握關鍵致勝分', img_url: require('@/assets/images/liveabcxwordup/cover/exam4.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/456?utm_source=publisher_liveabc' },
        { title: '打造屬於你的大考7000單字計畫初級1-2500字', text: '時間有限，從高頻單字規劃學習進度吧！', img_url: require('@/assets/images/liveabcxwordup/cover/exam5.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/377?utm_source=publisher_liveabc' },
        { title: '雅思高分必考單字', text: '擴充雅思單字量的終極百寶箱一次全給你！', img_url: require('@/assets/images/liveabcxwordup/cover/exam6.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/146?utm_source=publisher_liveabc' }
      ],
      sectionData3: [
        { title: '和全球做生意必備會議英語', text: '精通開會話術，打造商場英語溝通力', img_url: require('@/assets/images/liveabcxwordup/cover/work1.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/600?utm_source=publisher_liveabc' },
        { title: '和全球做生意必備簡報英語', text: '預約一場成功完美的英語簡報吧！', img_url: require('@/assets/images/liveabcxwordup/cover/work2.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/547?utm_source=publisher_liveabc' },
        { title: '和全球做生意-商務職場必備詞彙+實用句', text: '商業單字例句，用真實情境一次學足', img_url: require('@/assets/images/liveabcxwordup/cover/work3.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/445?utm_source=publisher_liveabc' },
        { title: '和全球做生意-商場&辦公室必備英語會話', text: '上班族一定要有的職場英語資料庫', img_url: require('@/assets/images/liveabcxwordup/cover/work4.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/444?utm_source=publisher_liveabc' }
      ],
      sectionData4: [
        { title: 'CNN主播教你一字一句聽懂新聞英語', text: '先聽CNN主播講一遍，超強英語聽力練習', img_url: require('@/assets/images/liveabcxwordup/cover/cnn1.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/573?utm_source=publisher_liveabc' },
        { title: 'CNN主播教你說英語-成功企業的奮鬥故事', text: '影音互動，原汁原味傳授品牌經營致勝之道', img_url: require('@/assets/images/liveabcxwordup/cover/cnn2.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/572?utm_source=publisher_liveabc' }
      ],
      sectionData5: [
        { title: '16堂培養核心素養的英文閱讀課-初級篇', text: '新課綱閱讀題打好基礎，就靠這套', img_url: require('@/assets/images/liveabcxwordup/cover/reading1.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/510?utm_source=publisher_liveabc' },
        { title: '16堂培養核心素養的英文閱讀課-進階篇', text: '新課綱閱讀題挑戰進階，就靠這套', img_url: require('@/assets/images/liveabcxwordup/cover/reading2.png'), class: 'w-full md:w-1/2', link: 'https://shop.wordup.com.tw/product/511?utm_source=publisher_liveabc' },
        { title: '英語模擬城市生活英語必學會話', text: '想和老外用英語溝通，就從日常生活做起', img_url: require('@/assets/images/liveabcxwordup/cover/reading3.png'), class: 'w-full md:w-1/3', link: 'https://shop.wordup.com.tw/product/579?utm_source=publisher_liveabc' },
        { title: '經典文學名著巡禮向大師學英語', text: '用文學大師經典故事，培養長期英文興趣', img_url: require('@/assets/images/liveabcxwordup/cover/reading4.png'), class: 'w-full md:w-1/3', link: 'https://shop.wordup.com.tw/product/568?utm_source=publisher_liveabc' },
        { title: 'ABC 英語故事袋系列套組', text: '培養孩子英文自學力，從小打下良好基礎。', img_url: require('@/assets/images/liveabcxwordup/cover/reading5.png'), class: 'w-full md:w-1/3', link: 'https://shop.wordup.com.tw/product/942?utm_source=publisher_liveabc' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.text-main {
  color: #3E6DBD;
}
.img-shadow {
  // border: 1px solid #E0E0E0;
  filter: drop-shadow(8px 8px 0px rgba(0, 0, 0, 0.25));
  border-radius: 20px;
}
.btn-intro {
  background: #828282;
  border-radius: 20px;
  color: white;
  padding: 0.8em 1em;
}
.skin-purple {
  background-color: #E7EEFE;
  background-image: url('~@/assets/images/liveabcxwordup/BG-BLUE.png');
  background-size: 100px;
  background-repeat: repeat;
}
.toeic {
  position: relative;
    &::after{
    content: "";
    position: absolute;
    left: 0;
    top: -40px;
    right: 0;
    background-repeat: repeat;
    height: 40px;
    background-size: 80px 80px;
    background-image:
      radial-gradient(circle at 40px 40px, #ffffff 38px, transparent 26px);
    transform: rotate(0deg);
    z-index: 0;
  }
}
.Exam {
  // background: #FFFAE6;
  background-image: url('~@/assets/images/liveabcxwordup/BG-YELLOW.png');
  background-size: 100px;
  background-repeat: repeat;
}
footer {
  color: #BDBDBD;
}

.wave-bottom {
  position: relative;
    &::after{
    content: "";
    position: absolute;
    left: 0;
    bottom: -40px;
    right: 0;
    background-repeat: repeat;
    height: 40px;
    background-size: 80px 80px;
    background-image:
      radial-gradient(circle at 40px 40px, #FFFAE6 38px, transparent 26px);
    transform: rotate(180deg);
    z-index: 0;
  }
}
</style>
